export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14603.c5dba8ba.jpg";